import { VCard } from "vuetify/lib";

import style from "./SpuDevStage.module.less";

export default {
  props: {
    status: String,
  },
  data() {
    return {};
  },
  computed: {
    statusClass() {
      return style["status-" + this.status];
    },
  },
  render() {
    return (
      <VCard class={`${style.card} ${this.statusClass}`}>
        <div class={style.title}>
          {this.$scopedSlots.title && this.$scopedSlots.title()}
        </div>
        <div class={style.content}>
          {this.$scopedSlots.content && this.$scopedSlots.content()}
        </div>
      </VCard>
    );
  },
};
